import { api } from './client';

export interface EmployeeForSelector {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  isActive: boolean;
}

export const employeesApi = {
  /**
   * Получить список сотрудников для селектора
   * @param all - если true, вернуть всех (включая уволенных)
   */
  getForSelector: async (all = false): Promise<EmployeeForSelector[]> => {
    const { data } = await api.get('/employees/for-selector', {
      params: all ? { all: 'true' } : undefined,
    });
    return data;
  },
};
